/**
 * gengql documents for the invitation confirmation page (ENG-6310).
 *
 * The staff MCP prepares a batch of invitations and hands back a link to this
 * page; nothing is emailed until the staff member who prepared them presses
 * Send here. The api only lets that person read, send or cancel the batch.
 *
 * The three batch documents select the same fields so the page can render the
 * batch the mutations return (the state they actually reached) without a
 * refetch. The preparer may edit the subject and body before sending; the edit
 * goes only with the send, and the preview query renders it meanwhile. When
 * Claude drafted the email at prepare (email_draft, ENG-6315), the editor
 * starts from that draft, which is sent only as the preparer's edit.
 */
import { gengql } from '@/__generated__';

export const GET_CANDIDATE_INVITATION_BATCH = gengql(/* GraphQL */ `
  query getCandidateInvitationBatch($token: String!) {
    candidateInvitationBatch(token: $token) {
      id
      state
      expert_request_id
      expert_request_name
      expert_request_stage
      sender {
        name
        email
      }
      recipients {
        candidate_id
        profile_id
        profile_name
        emails
      }
      email {
        subject
        body
      }
      email_template {
        subject
        body
      }
      email_draft {
        subject
        body
      }
      created_at
      expires_at
      sent_at
      cancelled_at
    }
  }
`);

export const SEND_CANDIDATE_INVITATION_BATCH = gengql(/* GraphQL */ `
  mutation sendCandidateInvitationBatch($token: String!, $subject: String, $body: String) {
    sendCandidateInvitationBatch(
      token: $token
      invitation_email_subject: $subject
      invitation_email_body: $body
    ) {
      id
      state
      expert_request_id
      expert_request_name
      expert_request_stage
      sender {
        name
        email
      }
      recipients {
        candidate_id
        profile_id
        profile_name
        emails
      }
      email {
        subject
        body
      }
      email_template {
        subject
        body
      }
      email_draft {
        subject
        body
      }
      created_at
      expires_at
      sent_at
      cancelled_at
    }
  }
`);

export const CANCEL_CANDIDATE_INVITATION_BATCH = gengql(/* GraphQL */ `
  mutation cancelCandidateInvitationBatch($token: String!) {
    cancelCandidateInvitationBatch(token: $token) {
      id
      state
      expert_request_id
      expert_request_name
      expert_request_stage
      sender {
        name
        email
      }
      recipients {
        candidate_id
        profile_id
        profile_name
        emails
      }
      email {
        subject
        body
      }
      email_template {
        subject
        body
      }
      email_draft {
        subject
        body
      }
      created_at
      expires_at
      sent_at
      cancelled_at
    }
  }
`);

// The invitation rendered for one recipient with the preparer's draft, which
// the api checks the way a send would. It stores nothing.
export const PREVIEW_CANDIDATE_INVITATION_EMAIL = gengql(/* GraphQL */ `
  query previewCandidateInvitationEmail(
    $token: String!
    $profileId: String
    $subject: String
    $body: String
  ) {
    candidateInvitationBatch(token: $token) {
      id
      email(
        profile_id: $profileId
        invitation_email_subject: $subject
        invitation_email_body: $body
      ) {
        subject
        body
      }
    }
  }
`);
